export const isPrerendering = () => navigator.userAgent === 'ReactSnap'
